function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ListingType, AnalyticsMetric } from '@domain-group/fe-allhomes-library';
import { ah, ga, mixpanel } from '@domain-group/fe-co-allhomes-analytics';
import { GAActions, GALabels, ListingTypeLabel, MixpanelLabels } from './constants';
import * as gs from './group-stats';
import galleryEventMapping from './galleries-event-mapper';
import * as ga4 from './ga4-handlers';
var isOffmarket = function isOffmarket() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return key.startsWith('off-market.');
};
var getListingTypeLabel = property => {
  var _property$listing;
  if (!(property !== null && property !== void 0 && (_property$listing = property.listing) !== null && _property$listing !== void 0 && _property$listing.status)) {
    return '';
  }
  if (property.listing.status === 'SOLD') {
    return 'sold';
  }
  if (property.listing.type) {
    var listingType = ListingType[property.listing.type].category;
    return listingType ? ListingTypeLabel[listingType] : '';
  }
  return '';
};
var getMixpanelEnquiryCTA = key => {
  if (key.includes('mobile-enquiry-cta')) {
    return MixpanelLabels.FLOATING_CTA;
  }
  if (key.includes('agency-details')) {
    return MixpanelLabels.ENQUIRY_FORM;
  }
  return MixpanelLabels.AGENT_INFO_BOX;
};
var getListingCategory = property => {
  var _property$listing2;
  if (property !== null && property !== void 0 && (_property$listing2 = property.listing) !== null && _property$listing2 !== void 0 && _property$listing2.type) {
    var _ListingType$property;
    var category = (_ListingType$property = ListingType[property.listing.type].category) === null || _ListingType$property === void 0 ? void 0 : _ListingType$property.toLowerCase();
    return category ? "".concat(category[0].toUpperCase()).concat(category.substring(1)) : '';
  }
  return '';
};
var eventMapper = _objectSpread(_objectSpread({
  '/(sales|rental|share|early-access|off-market)\\.page-view/': (key, _ref) => {
    var _property$listing3;
    var property = _ref.property,
      user = _ref.user;
    return _objectSpread(_objectSpread(_objectSpread({}, key.includes('off-market') ? {} : ah.listingMetric((property === null || property === void 0 ? void 0 : (_property$listing3 = property.listing) === null || _property$listing3 === void 0 ? void 0 : _property$listing3.id) || '', AnalyticsMetric.PAGE_VIEW)), gs.AdvertView({
      property: property,
      user: user
    })), mixpanel.viewListingDetail());
  },
  'early-access.page-view': () => ga.interaction(GAActions.EARLY_ACCESS, GALabels.EARLY_ACCESS_PAGE_LOAD),
  '/(development|build-to-rent)\\.page-view/': (_key, _ref2) => {
    var _property$listing4;
    var property = _ref2.property,
      utmMetadata = _ref2.utmMetadata;
    return ah.listingMetric((property === null || property === void 0 ? void 0 : (_property$listing4 = property.listing) === null || _property$listing4 === void 0 ? void 0 : _property$listing4.id) || '', AnalyticsMetric.PAGE_VIEW, utmMetadata ? {
      utmMetadata
    } : undefined);
  },
  '/(sales|rental|share).summary.show-more/': (_key, _ref3) => {
    var _property$listing5;
    var property = _ref3.property;
    return ah.listingMetric((property === null || property === void 0 ? void 0 : (_property$listing5 = property.listing) === null || _property$listing5 === void 0 ? void 0 : _property$listing5.id) || '', AnalyticsMetric.EXPAND_TEXT);
  },
  '/(sales|rental|development).calendar-click/': (key, _ref4) => {
    var _property$listing6;
    var property = _ref4.property,
      position = _ref4.position,
      title = _ref4.title;
    return _objectSpread(_objectSpread(_objectSpread({}, ah.listingMetric((property === null || property === void 0 ? void 0 : (_property$listing6 = property.listing) === null || _property$listing6 === void 0 ? void 0 : _property$listing6.id) || '', AnalyticsMetric.INSPECTION_TIME_SAVED)), ga4.addInspectionToCalendar('Inspections', position, 'LHS middle', '', title, 'svg_calendar_icon')), mixpanel.clickAddToCalendar({
      enquiryCTA: MixpanelLabels.INSPECTIONS_SECTION,
      calendarItemType: MixpanelLabels.INSPECTION
    }));
  },
  '/(sales|rental|development).(agent-sidebox|mobile).calendar-click/': (key, _ref5) => {
    var _property$listing7;
    var property = _ref5.property,
      text = _ref5.text;
    return _objectSpread(_objectSpread(_objectSpread({}, ah.listingMetric((property === null || property === void 0 ? void 0 : (_property$listing7 = property.listing) === null || _property$listing7 === void 0 ? void 0 : _property$listing7.id) || '', AnalyticsMetric.INSPECTION_TIME_SAVED)), ga4.addInspectionToCalendar('', '', 'RHS sticky sidebox', text, '', 'button')), mixpanel.clickAddToCalendar({
      enquiryCTA: MixpanelLabels.AGENT_INFO_BOX,
      calendarItemType: MixpanelLabels.INSPECTION
    }));
  },
  '/(sales|rental|development).private-inspections.book-inspection-click/': (_key, _ref6) => {
    var _property$listing8, _property$integration, _property$integration2;
    var property = _ref6.property;
    return _objectSpread(_objectSpread({}, ah.listingMetric((property === null || property === void 0 ? void 0 : (_property$listing8 = property.listing) === null || _property$listing8 === void 0 ? void 0 : _property$listing8.id) || '', AnalyticsMetric.BOOK_INSPECTION_CLICK)), mixpanel.clickBookInspection({
      bookingProvider: property === null || property === void 0 ? void 0 : (_property$integration = property.integrations) === null || _property$integration === void 0 ? void 0 : (_property$integration2 = _property$integration.bookInspection) === null || _property$integration2 === void 0 ? void 0 : _property$integration2.provider
    }));
  },
  '/(sales|rental|development).online-inspections.email-click/': (_key, _ref7) => {
    var _property$listing9;
    var property = _ref7.property,
      user = _ref7.user;
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, ah.listingMetric((property === null || property === void 0 ? void 0 : (_property$listing9 = property.listing) === null || _property$listing9 === void 0 ? void 0 : _property$listing9.id) || '', AnalyticsMetric.EMAIL_AGENT_CLICK)), ga.interaction(GAActions.INSPECTION_PLANNER, GALabels.CONTACT_AGENT)), gs.EmailEnquiryFormClick({
      property: property,
      user: user,
      EventSourceDetails: 'CantInspectContactAgent'
    })), mixpanel.displayContactAgentForm({
      enquiryCTA: MixpanelLabels.INSPECTIONS_SECTION
    }));
  },
  '/(sales|rental|development).video-click/': () => ga.interaction(GAActions.PROPERTY_WALKTHROUGH, GALabels.VIEW_WALKTHROUGH_VIDEO),
  '/(sales|rental|development).virtual-tour-click/': () => ga.interaction(GAActions.PROPERTY_WALKTHROUGH, GALabels.VIEW_WALKTHROUGH_3D),
  'sales.auction-calendar-click': (_key, _ref8) => {
    var _property$listing0;
    var property = _ref8.property;
    return _objectSpread(_objectSpread(_objectSpread({}, ah.listingMetric((property === null || property === void 0 ? void 0 : (_property$listing0 = property.listing) === null || _property$listing0 === void 0 ? void 0 : _property$listing0.id) || '', AnalyticsMetric.AUCTION_TIME_SAVED)), ga.conversion(GAActions.AUCTION, GALabels.ADD_AUCTION_TO_CALENDAR)), mixpanel.clickAddToCalendar({
      enquiryCTA: MixpanelLabels.INSPECTIONS_SECTION,
      calendarItemType: MixpanelLabels.AUCTION
    }));
  },
  '/(sales|rental|development).add-inspection-click/': (key, _ref9) => {
    var position = _ref9.position,
      title = _ref9.title;
    return _objectSpread(_objectSpread({}, mixpanel.clickAddToPlanner({
      enquiryCTA: MixpanelLabels.INSPECTIONS_SECTION
    })), ga4.addInspectionToPlanner(position, title));
  },
  'sales.online-auction-click': (_key, _ref0) => {
    var _property$listing1;
    var property = _ref0.property;
    return _objectSpread(_objectSpread({}, ah.listingMetric((property === null || property === void 0 ? void 0 : (_property$listing1 = property.listing) === null || _property$listing1 === void 0 ? void 0 : _property$listing1.id) || '', AnalyticsMetric.GOTO_ONLINE_AUCTION)), ga.interaction(GAActions.AUCTION, GALabels.ONLINE_AUCTION));
  },
  'sales.summary.online-auction-primary-cta-click': () => ga.interaction(GAActions.ONLINE_AUCTION, GALabels.ONLINE_AUCTION_PRIMARY_CTA),
  '/(sales|rental|share|development).directions-click/': () => mixpanel.clickDirections({
    enquiryCTA: MixpanelLabels.LISTING_MAP_CARD
  }),
  '/(sales|rental|share|development).share.print-click/': (_key, _ref1) => {
    var position = _ref1.position;
    return ga4.shareButtonClick('Print', position !== null && position !== void 0 ? position : 0, '', 'print page');
  },
  '/(sales|rental|share|development).share.email-click/': (_key, _ref10) => {
    var property = _ref10.property,
      position = _ref10.position;
    return ga4.shareButtonClick('Email', position !== null && position !== void 0 ? position : 0, getListingCategory(property), 'email a friend');
  },
  '/(sales|rental|share|development).share.facebook-click/': (_key, _ref11) => {
    var _property$listing10;
    var property = _ref11.property,
      position = _ref11.position;
    return _objectSpread(_objectSpread({}, ah.listingMetric((property === null || property === void 0 ? void 0 : (_property$listing10 = property.listing) === null || _property$listing10 === void 0 ? void 0 : _property$listing10.id) || '', AnalyticsMetric.FACEBOOK_SHARE)), ga4.shareButtonClick('Facebook', position !== null && position !== void 0 ? position : 0, '', ''));
  },
  '/(sales|rental|share|development).share.twitter-click/': (_key, _ref12) => {
    var _property$listing11;
    var property = _ref12.property,
      position = _ref12.position;
    return _objectSpread(_objectSpread({}, ah.listingMetric((property === null || property === void 0 ? void 0 : (_property$listing11 = property.listing) === null || _property$listing11 === void 0 ? void 0 : _property$listing11.id) || '', AnalyticsMetric.TWITTER_SHARE)), ga4.shareButtonClick('Twitter', position !== null && position !== void 0 ? position : 0, '', ''));
  },
  '/(sales|rental|development|early-access)\\.([^.]*)\\.agency-sidebox-profile-click/': (key, _ref13) => {
    var _property$listing12;
    var property = _ref13.property,
      user = _ref13.user,
      agencyName = _ref13.agencyName,
      agencyId = _ref13.agencyId;
    return _objectSpread(_objectSpread(_objectSpread({}, ah.listingMetric((property === null || property === void 0 ? void 0 : (_property$listing12 = property.listing) === null || _property$listing12 === void 0 ? void 0 : _property$listing12.id) || '', AnalyticsMetric.VIEW_AGENCY_PROFILE)), gs.AgencyDetailsView({
      property: property,
      user: user,
      EventSourceDetails: key.includes('agent-sidebox') ? 'AgentDetailsTile' : 'ContactAgents'
    })), ga4.agencySideboxClick(agencyId, agencyName));
  },
  '/(sales|rental|development|early-access)\\.([^.]*)\\.agency-enquiry-profile-click/': (key, _ref14) => {
    var _property$listing13;
    var property = _ref14.property,
      user = _ref14.user,
      agencyName = _ref14.agencyName,
      agencyId = _ref14.agencyId;
    return _objectSpread(_objectSpread(_objectSpread({}, ah.listingMetric((property === null || property === void 0 ? void 0 : (_property$listing13 = property.listing) === null || _property$listing13 === void 0 ? void 0 : _property$listing13.id) || '', AnalyticsMetric.VIEW_AGENCY_PROFILE)), gs.AgencyDetailsView({
      property: property,
      user: user,
      EventSourceDetails: key.includes('agent-sidebox') ? 'AgentDetailsTile' : 'ContactAgents'
    })), ga4.agencyEnquiryClick(agencyId, agencyName));
  },
  '/(sales|rental|development|early-access)\\.([^.]*)\\.agent-sidebox-profile-click/': (key, _ref15) => {
    var _property$listing14;
    var property = _ref15.property,
      agentId = _ref15.agentId,
      agentName = _ref15.agentName,
      agencyId = _ref15.agencyId,
      agencyName = _ref15.agencyName;
    return _objectSpread(_objectSpread(_objectSpread({}, ah.listingMetric((property === null || property === void 0 ? void 0 : (_property$listing14 = property.listing) === null || _property$listing14 === void 0 ? void 0 : _property$listing14.id) || '', AnalyticsMetric.VIEW_AGENT_PROFILE, {
      agentId: agencyId,
      agentstaffId: agentId
    })), mixpanel.clickToViewAgentProfile({
      enquiryCTA: getMixpanelEnquiryCTA(key)
    })), ga4.agentProfileSideboxClick(agentId, agentName, agencyId, agencyName));
  },
  '/(sales|rental|development|early-access)\\.([^.]*)\\.agent-enquiry-profile-click/': (key, _ref16) => {
    var _property$listing15;
    var property = _ref16.property,
      agentId = _ref16.agentId,
      agentName = _ref16.agentName,
      agencyId = _ref16.agencyId,
      agencyName = _ref16.agencyName;
    return _objectSpread(_objectSpread(_objectSpread({}, ah.listingMetric((property === null || property === void 0 ? void 0 : (_property$listing15 = property.listing) === null || _property$listing15 === void 0 ? void 0 : _property$listing15.id) || '', AnalyticsMetric.VIEW_AGENT_PROFILE, {
      agentId: agencyId,
      agentstaffId: agentId
    })), mixpanel.clickToViewAgentProfile({
      enquiryCTA: getMixpanelEnquiryCTA(key)
    })), ga4.agentProfileEnquiryClick(agentId, agentName, agencyId, agencyName));
  },
  '/.*\\.call-reveal$/': (key, _ref17) => {
    var _property$listing16;
    var property = _ref17.property,
      agentId = _ref17.agentId,
      agentName = _ref17.agentName,
      agencyId = _ref17.agencyId,
      agencyName = _ref17.agencyName,
      index = _ref17.index;
    return _objectSpread(_objectSpread(_objectSpread({}, ah.listingMetric((property === null || property === void 0 ? void 0 : (_property$listing16 = property.listing) === null || _property$listing16 === void 0 ? void 0 : _property$listing16.id) || '', AnalyticsMetric.PHONE_CLICK)), key.includes('mobile-enquiry-cta') ? ga.conversion("".concat(GAActions.CLICK_TO_REVEAL_PREFIX).concat(getListingTypeLabel(property)), GALabels.FOOTER_CTA) : ga4.callReveal(key, agentId, agentName, agencyId, agencyName, index)), mixpanel.revealPhone({
      enquiryCTA: getMixpanelEnquiryCTA(key)
    }));
  },
  '/(sales|rental|share|development|early-access).agent-sidebox.email-click/': (_key, _ref18) => {
    var _property$listing17;
    var property = _ref18.property;
    return _objectSpread(_objectSpread(_objectSpread({}, ah.listingMetric((property === null || property === void 0 ? void 0 : (_property$listing17 = property.listing) === null || _property$listing17 === void 0 ? void 0 : _property$listing17.id) || '', AnalyticsMetric.EMAIL_AGENT_CLICK)), ga.interaction(GAActions.EMAIL_AGENT, GALabels.AGENT_INFO_BOX)), mixpanel.displayContactAgentForm({
      enquiryCTA: MixpanelLabels.AGENT_INFO_BOX
    }));
  },
  '/(sales|rental|share|development|early-access).mobile-enquiry-cta.email-click/': (_key, _ref19) => {
    var _property$listing18;
    var property = _ref19.property;
    return _objectSpread(_objectSpread(_objectSpread({}, ah.listingMetric((property === null || property === void 0 ? void 0 : (_property$listing18 = property.listing) === null || _property$listing18 === void 0 ? void 0 : _property$listing18.id) || '', AnalyticsMetric.EMAIL_AGENT_CLICK)), ga.interaction(GAActions.EMAIL_AGENT, GALabels.FOOTER_CTA)), mixpanel.displayContactAgentForm({
      enquiryCTA: MixpanelLabels.FLOATING_CTA
    }));
  },
  '/(sales|rental|share|development|early-access).private-inspections.email-click/': () => mixpanel.displayContactAgentForm({
    enquiryCTA: MixpanelLabels.INSPECTIONS_SECTION
  }),
  '/(sales|rental|development)\\.([^.]*)\\.apply-online-click/': (_key, _ref20) => {
    var _property$listing19;
    var property = _ref20.property;
    return _objectSpread(_objectSpread({}, ah.listingMetric((property === null || property === void 0 ? void 0 : (_property$listing19 = property.listing) === null || _property$listing19 === void 0 ? void 0 : _property$listing19.id) || '', AnalyticsMetric.APPLY_ONLINE)), ga.interaction('Click "Apply Online" link', 'Apply Online'));
  },
  '/(sales|rental|development|early-access).send-enquiry/': (_key, _ref21) => {
    var property = _ref21.property,
      options = _ref21.options,
      enquiryFormVersion = _ref21.enquiryFormVersion;
    return _objectSpread(_objectSpread({}, ga4.sendEnquiry(property, options)), mixpanel.emailEnquiry({
      enquiryReasons: options,
      enquiryFormVersion
    }));
  },
  '/(sales|rental|development|early-access).summary.agency.logo-click/': (_key, _ref22) => {
    var _property$listing20;
    var property = _ref22.property,
      agencyName = _ref22.agencyName,
      agencyId = _ref22.agencyId;
    return _objectSpread(_objectSpread({}, ah.listingMetric((property === null || property === void 0 ? void 0 : (_property$listing20 = property.listing) === null || _property$listing20 === void 0 ? void 0 : _property$listing20.id) || '', AnalyticsMetric.EMAIL_AGENT_CLICK)), ga4.agencySideboxClick(agencyId, agencyName));
  },
  'early-access.past-sales-click': () => ga.interaction(GAActions.EARLY_ACCESS, GALabels.VIEW_PAST_SALES),
  'off-market.find-an-agent': () => ga.interaction(GAActions.FIND_AN_AGENT, GALabels.FIND_AN_AGENT_OFF_MARKET_CTA),
  'featured-article.article-click': () => ga.conversion(GAActions.EDITORIAL_SHOWCASE, 'Onmarket - Inline - Click'),
  'off-market-advice.article-click': () => ga.conversion(GAActions.EDITORIAL_SHOWCASE, 'Offmarket - Inline - Click'),
  'suburb-articles.article-click': (key, _ref23) => {
    var article = _ref23.article;
    return ga.conversion(GAActions.EDITORIAL_SHOWCASE, "".concat(isOffmarket(key) ? 'Offmarket' : 'Onmarket', " - ").concat(article.tags.includes('postcodes') ? 'Postcodes' : 'Location', " - Click"));
  },
  '/nearby-sales-click/': () => ga4.nearbySalesClick(),
  'nearby-sales-sign-in': () => ga.interaction(GAActions.NEARBY_SALES_ONMARKET, GALabels.OPEN_SIGN_IN),
  'sponsorship-viewed': () => ga.interaction(GAActions.LISTING_ENQUIRY_FORM, GALabels.VIEWED_CAMPAIGN),
  'sponsorship-clicked': () => ga.interaction(GAActions.LISTING_ENQUIRY_FORM, GALabels.CLICKED_LEARN_MORE),
  'display-research-cta': () => mixpanel.displayResearchCta({
    interactionCTA: MixpanelLabels.VIEW_SUBURB_PROFILE
  }),
  '/click-research-cta$/': () => mixpanel.clickResearchCta({
    interactionCTA: MixpanelLabels.VIEW_SUBURB_PROFILE_CLICK
  }),
  'click-research-cta-sticky': () => mixpanel.clickResearchCta({
    interactionCTA: MixpanelLabels.VIEW_SUBURB_PROFILE_STICKY
  }),
  '/\\.summary\\.nbn-card-view/': () => mixpanel.displayNBNConnectivityCard(),
  '/\\.summary\\.nbn-disclaimer-click$/': () => mixpanel.clickToDisplayNBNDisclaimer(),
  '/\\.summary\\.nbn-info-click$/': () => mixpanel.clickToDisplayNBNInfo(),
  'display-my-followed-property': () => mixpanel.displayMyFollowedProperty(),
  'follow-property-click': () => mixpanel.clickFollowAnotherProperty(),
  '/(sales|rental|development|early-access|share).summary.show-more/': () => _objectSpread({}, ga4.viewMoreClick())
}, galleryEventMapping), {}, {
  '/add-to-watchlist/': (_key, _ref24) => {
    var property = _ref24.property;
    return ga4.addToWatchlist(property);
  },
  '/inspection-planner-link-click/': () => ga4.inspectionPlannerLinkClick(),
  'sales.peppermoney-cta-click': _key => mixpanel.clickPepperMoneyCta()
});
export default eventMapper;